<script lang="ts">
	import chevronLeft from '$lib/assets/images/icons/chevron-left.svg';
	import chevronRight from '$lib/assets/images/icons/chevron-right.svg';
	import advantages1 from '$lib/assets/images/advantages-1.svg';
	import advantages2 from '$lib/assets/images/advantages-2.svg';
	import advantages3 from '$lib/assets/images/advantages-3.svg';
	import { Splide, SplideTrack } from '@splidejs/svelte-splide';
	import '@splidejs/splide/dist/css/splide.min.css';
	import Advantage from './Advantage.svelte';
	import __ from '$lib/stores/TranslationStore';
	import { onMount } from 'svelte';
	let options: any = {
		type: 'loop'
	};
	onMount(() => {
		options = {
			type: 'loop',
			autoWidth: true,
			focus: 'center',
			snap: true,
			breakpoints: {
				640: {
					arrows: false,
					autoWidth: false
				}
			}
		};
	});
</script>

<div class="bg-white">
	<div class="advantages py-16">
		<div class="container mx-auto">
			<h3 class="text-2xl !leading-54 text-dark lg:text-5xl">
				{$__('Vantagens')}
			</h3>
		</div>
		<Splide hasTrack={false} {options}>
			<SplideTrack>
				<Advantage
					image={advantages2}
					title={$__('100% gratuito')}
					description={$__(
						'Não existem comissões ou valores extra para o seu processo de crédito.'
					)}
				/>
				<Advantage
					image={advantages1}
					title={$__('Serviço personalizado')}
					description={$__(
						'Profissionais dedicados na missão de proporcionar uma experiência personalizada e um acompanhamento contínuo e atencioso desde o primeiro momento.'
					)}
				/>
				<Advantage
					image={advantages3}
					title={$__('Mais tempo para si')}
					description={$__(
						'Tratamos de toda burocracia e negociação. Criamos uma relação de confiança e cuidado para que tenha mais tempo para si enquanto nós tratamos de tudo.'
					)}
				/>
			</SplideTrack>

			<div class="splide__arrows z-20 hidden md:block">
				<img
					src={chevronLeft}
					alt="anterior"
					class="splide__arrow splide__arrow--prev !h-72 !bg-transparent"
				/>
				<img
					src={chevronRight}
					alt="seguinte"
					class="splide__arrow splide__arrow--next !h-72 !bg-transparent"
				/>
			</div>
		</Splide>
	</div>
</div>
